import { LiteralValue } from './LiteralValue';

export class StringValue extends LiteralValue<string> {}
